import React from 'react';
import { Locale } from '@royalaholddelhaize/ah-web-core';
import { createTestHook } from '../../../../utils/create-test-hook';
import { AttentionMessage } from '../../../attention-message/attention-message';
import { AttentionMessageText } from '../../../attention-message/elements/attention-message-text';
import { getImageUploadTranslations } from '../../i18n/get-translations';
import css from './file-upload-error.module.scss';

interface FileUploadErrorProps {
    locale: Locale;
    errorCode: number;
}

export const FileUploadError: React.FC<
    FileUploadErrorProps & React.ComponentProps<'div'>
> = ({ locale, errorCode, ...restProps }) => {
    const { t } = getImageUploadTranslations(locale);

    return (
        <AttentionMessage
            className={css.root}
            {...createTestHook('file-upload-error')}
            {...restProps}
        >
            <AttentionMessageText as="span">
                {t(`upload-error-${errorCode}`)}
            </AttentionMessageText>
        </AttentionMessage>
    );
};
